import React from "react";
import bg from "images/section-bg-licensing.jpg";
import { HelpWithLicenseContainer } from "./styles";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

function HelpWithLicense() {
  return (
    <HelpWithLicenseContainer>
      <h2 className="license-title">Not Sure What License You Need?</h2>
      <Link to="/licensing/inquiry">
        <Button className="license-button" variant="contained">
          Contact us
        </Button>
      </Link>
    </HelpWithLicenseContainer>
  );
}

export default HelpWithLicense;
